import React from 'react'

const Line = () => {
  return <div className='line'></div>
}

export default Line
